import axios from '../utils/axios'
import { apis } from "../constants/apis";
import { getStaticConfigs } from "../helpers/common";

export async function getListUpdateHistory(payload: any)
{
      const staticConfigs = await getStaticConfigs();
      const _url = staticConfigs?.REACT_APP_API_BASE_URL_CBD;
      return axios.get(`${_url}${apis.history.getListUpdate}`, { params: { ...payload } });

}

export async function getListDownloadHistory(payload: any)
{
      const staticConfigs = await getStaticConfigs();
      const _url = staticConfigs?.REACT_APP_API_BASE_URL_CBD;
      return axios.get(`${_url}${apis.history.getListDownload}`, { params: { ...payload } });

}